<template>
  <div class="videoBox">
    <p class="font20 mb20 fontw">课程视频</p>
    <el-row class="children" :gutter="18">
      <el-col v-for="(item, index) in tableData" :key="index" :span="index == 0 ? 12 : 6">
        <list-item
          class="bacf"
          :class="index == 0 ? 'bigVideo' : ''"
          :data="item"
          v-czc="[
            '行业看点-视频',
            '点击列表',
            `全部视频列表`,
            index + 1,
            `hykdVideo-list-all`,
          ]"
          :visitlocation="'课程视频'"
        ></list-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ListItem from "../../video/components/list-item";
export default {
  components: { ListItem },
  data() {
    return {
      margin: "40px auto",
      detail: "",
      tableData: [],
    };
  },
  mounted() {
    this.queryData();
  },
  methods: {
    queryData() {
      this.$get(
        `${this.$store.state.api.webUrl}/video/onhomepagelist.json`,
        {
          limit: 5,
        },
        (data) => {
          this.tableData = data;
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
.videoBox {
  width: 100%;
  padding-top: 16px;
}
.bigVideo {
  height: 544px;
}
</style>
<style>
.bigVideo .img {
  height: 450px !important;
}
</style>
